import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { shallow } from "zustand/shallow";

import useDashboardStore from "@/state/dashboard";
import usePrepareDataForTab345 from "./hooks/usePrepareDataForTab345";

import KeyIndicators from "./layouts/KeyIndicators";
import Bulletin from "./layouts/Bulletin";
import useAdditionalLocale from "@/hooks/App/useAdditionalLocale";

import locales from "./locales";
import DataQuality from "./layouts/DataQuality";

const Dashboard8 = () => {
  useAdditionalLocale("en", locales.en);
  useAdditionalLocale("lo", locales.lo);
  const { t } = useTranslation();
  const {
    selectWidgetChild,
    dashboardState,
    changeAdditionalStateProperty,
    additionalState,
  } = useDashboardStore(
    (state) => ({
      selectWidgetChild: state.selectWidgetChild,
      dashboardState: state.dashboardState,
      changeAdditionalStateProperty: state.changeAdditionalStateProperty,
      additionalState: state.additionalState,
    }),
    shallow
  );

  const { dashboardOupSelectedTab } = additionalState;
  const prepareData = usePrepareDataForTab345();

  useEffect(() => {
    changeAdditionalStateProperty("dashboardOupSelectedTab", 0);
  }, []);

  switch (dashboardOupSelectedTab) {
    case 0:
      return <Bulletin {...prepareData} />;
    case 1:
      return <KeyIndicators />;
    case 2:
      return <DataQuality />;

    default:
      return <div>to be filled</div>;
  }
};

export default Dashboard8;
